import type {
  voucherDetailResource,
  voucherResource,
} from '@porotutu/api/features/crm/vouchers/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { VOUCHERS } from '@/api/keys'
import type { CrmVoucherSort, VoucherType } from '../vocabulary'

export type Voucher = ReturnType<typeof voucherResource>

export type VoucherDetail = ReturnType<typeof voucherDetailResource>

export type VoucherPage = { data: Voucher[]; meta: ListMeta }

export const ACTIVITY = ['true', 'false'] as const

export type Activity = (typeof ACTIVITY)[number]

export type VoucherListQuery = ListQuery<CrmVoucherSort, never> & {
  campaign_id?: string
  holder_customer_id?: string
  voucher_type?: VoucherType
  active?: Activity
}

export const sentQuery = ({ active, ...rest }: VoucherListQuery) => ({
  ...rest,
  active: active === undefined ? undefined : active === 'true',
})

export const vouchersQuery = (query: VoucherListQuery) =>
  queryOptions({
    queryKey: [...VOUCHERS, 'list', query] as const,
    queryFn: async () => unwrap(await crm.vouchers.get({ query: sentQuery(query) })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const voucherQuery = (id: string) =>
  queryOptions({
    queryKey: [...VOUCHERS, 'record', id] as const,
    queryFn: async () => unwrap(await crm.vouchers({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<VoucherListQuery>('/api/v1/crm/vouchers/export', {
  always: ['campaign_id', 'holder_customer_id'],
  viewed: ['voucher_type', 'active', 'search'],
})
